import { useMemo } from "react";
import { showToast } from "../../primitives";
import type { Command, CommandContext } from "../types";

/**
 * System commands (S3.13) — meta commands about the palette / app itself.
 */
export function useSystemCommands(ctx: CommandContext): Command[] {
  const { openCheatsheet, openCopyEndpoint } = ctx;
  return useMemo<Command[]>(
    () => [
      {
        id: "system:shortcuts",
        label: "Show keyboard shortcuts",
        icon: "keyboard",
        kind: "system",
        keywords: ["cheatsheet", "help", "keys", "shortcuts"],
        execute: () => openCheatsheet(),
      },
      {
        // Sprint 17 — pick + copy any MCP endpoint URL (/mcp, /mcp/admin, …).
        id: "system:copy-mcp-endpoint",
        label: "Copy MCP endpoint URL",
        icon: "plug",
        kind: "system",
        keywords: ["mcp", "endpoint", "url", "connect", "copy", "cursor", "admin", "lite"],
        execute: () => openCopyEndpoint(),
      },
      {
        id: "system:about",
        label: "About Kuvio",
        icon: "info-circle",
        kind: "system",
        keywords: ["help", "version", "about"],
        execute: () => showToast("Kuvio — a structured knowledge workspace for AI agents"),
      },
    ],
    [openCheatsheet, openCopyEndpoint],
  );
}
